<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="600px"
    :innerScroll="false"
    :contentLoading="loading"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form
      ref="addForm"
      :model="addForm"
      :rules="rules"
      :disabled="isView"
      label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model.trim="addForm.title" size="small" :maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="addForm.type" size="small" clearable @change="changeType">
          <el-option v-for="item in typeOptions"
            :key="item.dictDataCode"
            :label="item.dataDesc"
            :value="item.dictDataCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <div class="typeBox">
          <el-upload
            class="upload-demo"
            action=""
            :show-file-list="false"
            :http-request="videoUploadImg"
            :disabled="!addForm.type"
            :accept="accept"
          >
            <div v-if="addForm.type == 'mp4'">
              <el-button v-if="!addForm.content" size="small" type="primary" @click="beforeUpload">点击上传</el-button>
              <video v-else :src="addForm.content" style="width: 100px;height: 100px;"></video>
            </div>
            <el-button v-else size="small" type="primary" @click="beforeUpload">点击上传</el-button>
            
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="链接" prop="content">
        <el-input v-model.trim="addForm.content" size="small" :maxlength="1000"></el-input>
      </el-form-item>
      <el-form-item label="封面" prop="cover">
        <el-upload
          class="prizeImg-uploader"
          action=""
          accept="image/gif, image/jpeg, image/png"
          :show-file-list="false"
          :http-request='uploadImg'
          >
          <img v-if="addForm.cover" :src="addForm.cover" class="prizeImg">
          <i v-else class="el-icon-plus prizeImg-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      
     
    </el-form>
  </q-dialog>
</template>

<script>
import {assignValue} from '@/utils/'
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    modifyData: Object,
    // 1:新增  2:修改  3:查看
    actionType: Number,
    typeOptions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    title() {
      const titleMap = {
        1: '新增',
        2: '修改',
        3: '查看',
      };
      return titleMap[this.actionType];
    },
    isView() {
      return this.actionType == 3;
    }
  },
  data() {
    return {
      addForm: {
        title: '',
        type: '',
        typeName: '',
        content: '',
        cover: '',
        id: '',
      },
      fileType: {
        mp4: 'video/mp4, video/avi,video/m4v, video/wmv, video/flv',
        pdf: '.pdf',
        word: '.doc, .docx, .docm',
      },
      accept: 'video/mp4, video/avi,video/m4v, video/wmv, video/flv',
      rules: {
        title: [
          {required: true, message: '标题不能为空', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '类型不能为空', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '内容不能为空', trigger: 'change'}
        ],
      },
      loading: false,
      isClike: true
    }
  },
  methods: {
    init() {
      if (this.modifyData) {
        this.initModifyData();
        this.accept = this.fileType[this.modifyData.type]
      }
    },
    initModifyData() {
      assignValue(this.addForm, this.modifyData);
    },
    changeType(e) {
      this.accept = this.fileType[e]
      this.addForm.content = ''
    },
    beforeUpload() {
      if (!this.addForm.type) {
        this.$message.error("请先选择上传类型!");
      }
    },
    videoUploadImg(file) {
      let map = {
        mp4: /\.(mp4|avi|wmv|flv|m4v)$/,
        pdf: /\.(pdf)$/,
        word: /\.(doc|docx|wmv|docm)$/, 
      }
      let a = map[this.addForm.type];
      const isType = a.test(file.file.name);
      if (!isType) {
        this.$message.error("请上传正确的视频格式!");
        return
      }
      this.loading = true;
      this.$api.common.uploadFile(file.file)
          .then(({ data}) =>{
            this.addForm.content = data.fileUrl || '';
          })
          .finally(_ => {
            this.loading = false;
          });
    },
    uploadImg(file){
      const isLt2M = file.file.size / 1024 / 1024 < 3;
      let a = /\.(jpg|jepg|gif|png)$/;
      const isType = a.test(file.file.name);
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 3MB!");
        return
      }
      if (!isType) {
        this.$message.error("请上传jpg/png图片!");
        return
      }
      this.loading = true;
      this.$api.common.uploadImg(file.file)
          .then(({ data}) =>{
            this.addForm.cover = data[0] && data[0].fileUrl || '';
            this.$refs.addForm.clearValidate('cover');
          })
          .finally(_ => {
            this.loading = false;
          });
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      if (this.loading) {
        return;
      }
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        if (this.isClike) {
          this.isClike = false
          let params = {
          ...this.addForm
          };
          this.loading = true;
          this.$api.help
            .saveOrUpdate(params)
            .then(({ data }) => {
              const message = this.modifyData ? '修改成功': '创建成功';
              this.$notify.success({
                title: '成功',
                message,
              })
              this.isVisible = false
              this.$emit('success')
            })
            .finally(_ => {
              this.loading = false;
              setTimeout(()=> {
                this.isClike = true
              })
            },500);
        }
      })
    },
  },
  created() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
.form-input
  width 120px
.input-number
  width 120px
  >>> .el-input__inner
    text-align left
.typeBox {
  display: flex;
  align-items: center;
}
.prizeImg-uploader
  >>>.el-upload {
    border: 1px dashed  #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  &:hover 
    border-color: #0bb78e;
  .prizeImg-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }
  .prizeImg {
    width: 130px;
    height: 130px;
    display: block;
  }
</style>